<style lang="scss">
    .license-agreements {
        overflow-y: auto;

        &__agree {
            margin-top: 30px;
        }

        .licenses-wrapper {
            max-height: 400px;
        }

        .license-heading{
            font-size: 18px;
            padding-bottom: 40px;
            .nav-menu{
                display : flex;
                .navigation{
                    font-size: 40px;
                    color: #FF1466;
                    margin-left: 10px;
                    margin-right: 10px;
                    cursor: pointer;
                }

                .nav-text{
                    margin-top: 6px;
                }
            }

        }

        #current-license{
            min-height: 350px;
            overflow-y: auto;
            border-radius: 5px;
            ::-webkit-scrollbar {
                width : 10px;

            }

            ::-webkit-scrollbar-button{
                border-radius: 5px;
            }
        }

        .license-buttons{
            margin-top: 10px;
        }

        .md-check > i:before{
            width: 16px !important;
            height: 16px !important;
            border-radius: 3px !important;
            border: 1px solid #a7a7a7 !important;
        }

        .md-check > i:after{
            left: 6px !important;
            top: 1px !important;
            width: 5px !important;
            height: 12px !important;
        }

		.continue-button{
			padding: 10px 20px !important;
			margin-top: 30px;
		}

    }

    @media screen and (max-width: 500px) {
        .license-agreements{
            .p-a-lg {
                padding: 2rem !important;
            }

            .continue-button{
                width: 100% !important;
            }
        }
    }
</style>
<template>

<div class="license-agreements modal fade" id="license-agreements" :style="$modalBackgroundStyle">
		<a data-dismiss="modal" class="text-lg p-x modal-close-btn">×</a>
		 <div class="row-col">
            <div class="p-a-lg h-v row-cell v-m">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                        <div class="row">
                            <div class="row item-list item-list-sm item-list-by m-b">
                                <div class="col-xs-12">
                                    <h4 class="modal-title" :style="$highlightColor">License Agreements</h4>
                                    <div v-if="currentLicense">
                                        <div class="tw-flex tw-items-start tw-justify-between tw-text-lg tw-flex tw-items-center">
                                            <div class="tw-mb-2">
                                              <div class="tw-flex tw-flex-col">
                                                <strong class="tw-text-infinity-primary-text">{{ currentLicense.name }}</strong>
                                                <span class="tw-text-infinity-tertiary-text tw-text-sm">{{ currentLicense.typeLabel }}</span>
                                              </div>
                                            </div>
                                          <div class="tw-ml-2 tw-inline-grid tw-gap-2 tw-grid-flow-col tw-whitespace-nowrap tw-items-center">
                                            <div v-if="currentLicense.position > 0"
                                                 class="tw-text-xl tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-text-infinity-button-text tw-bg-infinity-button-background tw-cursor-pointer"
                                                 @click="prevLicense">
                                              <font-awesome-icon :icon="['fal','angle-left']"></font-awesome-icon>
                                            </div>
                                            <div class="tw-text-infinity-primary-text">
                                              License
                                              {{ currentLicense.position + 1 }}
                                              of
                                              {{ licenses.length }}
                                            </div>
                                            <div v-if="currentLicense.position + 1 < licenses.length"
                                                 class="tw-text-xl tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-text-infinity-button-text tw-bg-infinity-button-background tw-cursor-pointer"
                                                 @click="nextLicense">
                                              <font-awesome-icon :icon="['fal','angle-right']"></font-awesome-icon>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tw-bg-infinity-background tw-p-3 tw-border-solid tw-border tw-border-infinity-border tw-max-h-40" v-html="currentLicense.content" id="current-license"></div>
                                    </div>

                                    <div class="license-agreements__agree checkbox needsclick text-center">
                                        <label class="md-check m-y-md" data-target="folded">
                                            <input type="checkbox" name="agree" value="1" v-model="agreedTerms" class="has-value needsclick" />
                                                <i class="green"></i>
                                            <span>I agree to the license agreement(s) above</span>
                                        </label>
                                    </div>

                                    <div class="row actions">
										<div class="col-xs-12 text-right">

											<a data-dismiss="modal" class="btn btn-sm continue-button" :style="$mainButtonStyle">Close</a>
										</div>
									</div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

	</div>
</template>
<script>
import Configure from "../../mixins/configure";
import SoundKit from "../../models/soundkit";
import {parseAgreementTags} from "../../../../shared/utils/parse-agreement-tags";

export default {
        mixins: [Configure],
        data() {
            return {
                currentLicense: null
            }
        },
		computed: {
            cartItems() {
                return this.$store.state.cart.getCart()
            },
            licenses() {
              const customerName = this.loggedInUser?.name ?? this.$store.state.name ?? 'CLIENT NAME';
              // const sellerName = this.$store.state.user.
              const tagsMap = {
                  customer_name: customerName,
              }
              return this.cartItems.reduce((licenses, { item, license }) => {
                const type = item.getType();
                // Ignore if has no license
                if (!license) {
                  return licenses;
                }

                // Handle Soundt Pack Product Pricing (License)
                if ((type === "soundkit")
                    && item.hasTerms(license)
                    && !licenses.some(l => l.id === license.agreement.id && l.type === type)) {
                  return [...licenses,
                    {
                      id: license.agreement.id,
                      type,
                      typeLabel: "Sound Packs",
                      name: license.pricingTemplateOption.name,
                      content: SoundKit.parseTerms(license),
                      position: licenses.length
                    }];
                }

                if (["service", "service_quote"].includes(type) && item.agreement) {
                    return [...licenses,
                    {
                      id: item.agreement.id,
                      type,
                      typeLabel: "Services",
                      name: license.name,
                      content: license.contract.clean,
                      position: licenses.length
                    }];
                }

                // Handle Beat License
                if (type === "beat"
                    && !licenses.some(l => l.id === license.id && l.type === type)) {
                  const content = license.contract.clean
                      .replace(/%MFS_ORDER_DATE%/g, moment().format("Do MMMM YYYY"))
                      .replace(/%ORDER_DATE%/g, moment().format("Do MMMM YYYY"))
                      .replace(/%MFS_BEAT_NAME%/g, "BEAT NAME")
                      .replace(/%BEAT_NAME%/g, "BEAT NAME")
                      .replace(/%MFS_CLIENT_NAME%/g, customerName)
                      .replace(/%CLIENT_NAME%/g, customerName);

                  return [...licenses, {
                    id: license.id,
                    type,
                    typeLabel: "Beats",
                    name: license.name,
                    content,
                    position: licenses.length
                  }]
                }

                return licenses
              }, []).map((license) => ({
                  ...license,
                  content: license.content && parseAgreementTags(license.content, tagsMap)
              }));
            },
            loggedInUser() {
                return this.$store.state.loggedInUser
            },
            agreedTerms:{
                get(){
                    return this.$store.getters['checkout/licensesTermsAgreed'];
                },
                set(value){
                    this.$store.commit('checkout/licensesTermsAgreed', value);
                }
            }
        },
		methods: {
            prevLicense: function() {
                if (this.currentLicense.position > 0) {
                    const newPosition = this.currentLicense.position - 1;
                    this.currentLicense = this.licenses[newPosition];
                    this.licenseScrollToTop();
                }
            },
            nextLicense: function() {
                if (this.currentLicense.position + 1 < this.licenses.length) {
                    const newPosition = this.currentLicense.position + 1;
                    this.currentLicense = this.licenses[newPosition];
                    this.licenseScrollToTop();
                }
            },
            licenseScrollToTop: function() {
                $("#current-license").scrollTop(0);
            }
        },
        watch: {
            'licenses': {
                handler(val) {
                    if (val && val.length > 0) {
                        this.currentLicense = val[0]
                    } else {
                        this.currentLicense = null
                        this.agreedTerms = true;
                    }
                },
                immediate: true
            }
        }
    }
</script>
